import { Form } from "antd"
import { TextTag, Button, Input } from "../../atoms"
import { withFormik } from "formik"
import React from "react"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import { registerByEmail } from "../../redux/actionCreators/auth"
import "./RegisterNewUserByEmail.scss"
import { EmailSignupValidation } from "../../validationSchema/EmailSigninSignupValidation"
import arrow from "../../assets/images/arrow.svg"
import {
  CREATE_ACCOUNT,
  ALREADY_REGISTERED,
  FINISH_SIGNIN,
  LOGIN_BUTTON,
  EMAIL_PLACEHOLDER,
  PASSWORD_PLACEHOLDER,
} from "../../constants/messages"
import _ from "../../utils/lodashUtils"

const FormItem = Form.Item

class S extends React.PureComponent {
  handleChangeEmail = (evt) => {
    this.props.handleChange(evt)
    this.props.setStatus({ statusError: "" })
  }

  render() {
    const {
      values,
      handleSubmit,
      handleChange,
      handleBlur,
      touched,
      errors,
      isSubmitting,
      isValid,
      setFieldTouched,
      isLoading,
      dirty,
      status,
    } = this.props

    let emailError = touched.email && errors.email ? errors.email : undefined
    let statusError =
      status && status.statusError ? status.statusError : undefined
    emailError = emailError ? emailError : statusError

    return (
      <div id="RegisterNewUserByEmail" className="">
        <div className="signin-text">
          <div className="backbtnflex">
            <div>
              <Link to="/register">
                <img src={arrow} alt="back" />
              </Link>
              <TextTag textType="spaceName">{FINISH_SIGNIN}</TextTag>
            </div>
          </div>
          <div className="noacc-text">
            <TextTag textType="sectionTextPrimary">
              {ALREADY_REGISTERED}
            </TextTag>
            <Link to="/login-email">
              <TextTag textType="linkText"> {LOGIN_BUTTON}</TextTag>
            </Link>
          </div>
        </div>
        <div className="separator"></div>
        <form onSubmit={handleSubmit}>
          <div className="input-wrapper">
            <FormItem validateStatus={emailError ? "error" : undefined}>
              <Input
                name="email"
                placeholder={EMAIL_PLACEHOLDER}
                value={values.email}
                onChange={this.handleChangeEmail}
                onBlur={handleBlur}
                autoComplete="off"
                error={emailError}
              />
            </FormItem>
          </div>
          <div className="input-wrapper">
            <FormItem
              validateStatus={
                touched.password && errors.password ? "error" : undefined
              }
            >
              <Input
                name="password"
                type="password"
                placeholder={PASSWORD_PLACEHOLDER}
                value={values.password}
                onChange={handleChange}
                onBlur={handleBlur}
                error={
                  touched.password && errors.password ? errors.password : ""
                }
                onInput={() => setFieldTouched("password", true)}
              />
            </FormItem>
          </div>
          <FormItem>
            <Button
              btnSize="large"
              btnType="primary"
              htmlType="submit"
              className="login-form-button"
              disabled={isLoading || !dirty || !isValid}
            >
              {CREATE_ACCOUNT}
            </Button>
          </FormItem>
        </form>
      </div>
    )
  }
}

export const RegisterNewUserByEmail = withFormik({
  validationSchema: EmailSignupValidation,
  mapPropsToValues: () => ({
    email: "",
    password: "",
  }),
  handleSubmit: async (
    values,
    { props, setStatus, setErrors, setSubmitting }
  ) => {
    props.registerByEmail(values, false).then((response) => {
      if (_.get(response, "status") === 400)
        setStatus({ statusError: _.get(response.data, "error") })
    })
  },
})(S)

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  isLoading: state.loadingState.isAuthenticating,
})

export default connect(mapStateToProps, { registerByEmail })(
  RegisterNewUserByEmail
)
